import React, { PureComponent } from "react";
import { Redirect } from 'react-router';
import * as myConstClass from '../../constant.js';
import $ from 'jquery';
import { toastr } from "react-redux-toastr";
import {
  Button,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input
} from "reactstrap";

const image = `https://workzonepro.workzoneplus.com/backend/img/Work-Zone-Plus-logo.png`;
const image2 = `https://workzonepro.workzoneplus.com/backend/img/clock.png`;

// const {logout} = props.location.state;
class LogInForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      form: '1',
      showPassword: false,
      toDashboard: false,
      timeOut: 5000,
      showCloseButton: true,
      progressBar: true,
      position: "top-right",
      submitted: false,
    };
    // this.login = this.login.bind(this);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }



  tick() {
    //alert(this.state.code);  alert(this.state.interval_dynamic);
    if (this.state.code && this.state.interval_dynamic == '2') {
      fetch(myConstClass.LOGIN_URL + `user/getqrscan/` + this.state.code + '/' + this.state.tenant_id
      ).then(response => response.json()).then((response) => {

        if (response) {
          //  this.setState({ form:0});
          this.setState({ code: response.org_code });
          this.setState({ tenant_id: response.tenant_id });
          this.setState({ interval_dynamic: response.interval_dynamic });
          this.setState({ form: 0 });
          this.setState({ qrcode: response.qrimage });
           this.setState({ logo: response.logo });
          this.setState({ title: response.title });
          // this.setState({ title:response.title});

        }
      })
        .catch();
    }
  }



  componentDidMount() {

    // localStorage.setItem('forget', '0');
    // window.location.href = '/';
    $('.main').css('background-image', 'none');
    $('.main').css('background-size', 'none');
    //alert('hii');
    // if(this.state.interval_dynamic=='2')
    // {
    this.interval = setInterval(() => this.tick(), 30000);
    // }
  }
  onFormCancel = () => {
    localStorage.clear();
    localStorage.setItem('scan', '0');
    window.location.href = '/';
  }
  onFormSubmit = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    // Guard against double-firing (e.g. button click + native form submit)
    if (this.state.submitted) return;

    this.setState({ submitted: true }, () => {
      setTimeout(() => this.setState({ submitted: false }), 5000);

      fetch(myConstClass.LOGIN_URL + `user/qrscan`, {
        method: 'POST',
        body: JSON.stringify($('#pform').serializeArray()),
      }).then(response => response.json()).then((response) => {
        var code = $("#code").val();
        if (response == 2) {
          toastr.error(
            'Error',
            "Please enter password..!",
            this.options
          )
        } else
          if (response == 3) {
            toastr.error(
              'Error',
              "password Does not exists..!",
              this.options
            )
          } else if (response) {
            this.setState({ code: response.org_code });
            this.setState({ tenant_id: response.tenant_id });
            this.setState({ interval_dynamic: response.interval_dynamic });
            this.setState({ form: 0 });
            this.setState({ qrcode: response.qrimage });
            this.setState({ logo: response.logo });
            this.setState({ title: response.title });

            // localStorage.setItem('qrscan', '0');
            // this.props.history.push({
            //   pathname : '/'+myConstClass.TENANT_PAGE_PATH+'/organizationqrcode/qrcode',

            //   state :{
            //   _id : response.qrimage,
            //   }
            //   }
            // );
            //localStorage.setItem('signup', '1');

            // toastr.success(
            //   'Success',
            //   "Password Sent Successfully on your email..!",
            //   this.options
            // )
            // window.location.href = '/';
          } else {
            toastr.error(
              'Error',
              "password Does not exists..!",
              this.options
            )
          }
      })
        .catch();


    });
  }



  render() {
    const { formData, submitted } = this.state;
    if (this.state.toDashboard === true) {
      window.location.href = '/dashboard';
      return <Redirect to='/dashboard' />
    }
    // interval_dynamic == '2' -> Dynamic QR (auto-refreshing), otherwise Static QR
    const isDynamic = this.state.interval_dynamic == '2';

    return (
      <React.Fragment>
        <style>{`
          /* ---------- QR code screen only ---------- */
          .qr-outer-wrap {
            display: flex;
            justify-content: center;
            padding: 24px 12px;
          }
          .qr-card {
            width: 100%;
            max-width: 460px;
            border: none;
            border-radius: 18px;
            overflow: hidden;
            box-shadow: 0 10px 35px rgba(15, 23, 42, 0.12);
          }
          .qr-brand-header {
            background: linear-gradient(135deg, #1d4ed8 0%, #3b82f6 100%);
            padding: 26px 24px 24px 24px;
            text-align: center;
          }
          .qr-brand-header img.brand-logo {
            height: 46px;
            object-fit: contain;
            filter: brightness(0) invert(1);
          }
          .qr-org-panel {
            background: #ffffff;
            padding: 30px 26px 28px 26px;
            text-align: center;
          }
          .qr-org-logo-wrap {
            display: flex;
            justify-content: center;
            margin-bottom: 16px;
          }
          .qr-org-logo-wrap img {
            height: 64px;
            object-fit: contain;
          }
          .qr-org-name {
            font-size: 19px;
            font-weight: 700;
            color: #0f172a;
            margin: 0 0 8px 0;
          }
          .qr-type-badge {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            font-size: 11.5px;
            font-weight: 600;
            letter-spacing: 0.4px;
            text-transform: uppercase;
            padding: 4px 12px;
            border-radius: 20px;
            margin-bottom: 22px;
          }
          .qr-type-badge.dynamic {
            background: #dbeafe;
            color: #1d4ed8;
          }
          .qr-type-badge.static {
            background: #e2e8f0;
            color: #475569;
          }
          .qr-type-dot {
            width: 6px;
            height: 6px;
            border-radius: 50%;
          }
          .qr-type-badge.dynamic .qr-type-dot {
            background: #2563eb;
            animation: qr-pulse 1.4s infinite ease-in-out;
          }
          .qr-type-badge.static .qr-type-dot {
            background: #64748b;
          }
          .qr-code-frame {
            position: relative;
            width: 280px;
            height: 280px;
            margin: 0 auto 20px auto;
            padding: 18px;
            border-radius: 20px;
            background: #ffffff;
            border: 1.5px solid #dbeafe;
            box-shadow: 0 8px 24px rgba(37, 99, 235, 0.10);
          }
          .qr-code-frame img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
          .qr-corner {
            position: absolute;
            width: 22px;
            height: 22px;
            border-color: #2563eb;
            border-style: solid;
          }
          .qr-corner.tl { top: -2px; left: -2px; border-width: 3px 0 0 3px; border-top-left-radius: 8px; }
          .qr-corner.tr { top: -2px; right: -2px; border-width: 3px 3px 0 0; border-top-right-radius: 8px; }
          .qr-corner.bl { bottom: -2px; left: -2px; border-width: 0 0 3px 3px; border-bottom-left-radius: 8px; }
          .qr-corner.br { bottom: -2px; right: -2px; border-width: 0 3px 3px 0; border-bottom-right-radius: 8px; }

          .qr-instructions {
            font-size: 13.5px;
            color: #64748b;
            max-width: 300px;
            margin: 0 auto 22px auto;
            line-height: 1.5;
          }
          @keyframes qr-pulse {
            0% { opacity: 0.4; transform: scale(0.85); }
            50% { opacity: 1; transform: scale(1.15); }
            100% { opacity: 0.4; transform: scale(0.85); }
          }
          .qr-back-btn {
            background: #2563eb !important;
            border: none !important;
            border-radius: 10px !important;
            font-weight: 600;
            padding: 10px 32px !important;
            box-shadow: 0 4px 12px rgba(37,99,235,0.28);
          }
        `}</style>

        <div className="text-center mt-4">
          {/* <h1 className="h2">Reset password</h1> */}

        </div>
        <Card>
          <CardBody>
            <div className="m-sm-4">
           
            <div style={this.state.form == '1' ? { display: 'block' } : { display: 'none' }}>
                           <div className="text-center">
                             {/* <img src={image2} style={{'width':'40px','height':'40px'}}></img> */}
                             <img src={image2} style={{ 'width': '40px', 'height': '40px;' }} ></img>
                             <img src={image} style={{ 'width': '250px', 'height': '38px;' }}></img>
           
                           </div><br /><br />
                           <p className="lead">Enter your organization password for Qr code</p>
                           <Form className="form" id="pform" onSubmit={this.onFormSubmit}  >
                             <FormGroup>
                               <Label>organization Code</Label>
                               <Input
                                 bsSize="lg"
                                 type="text"
                                 id="code"
                                 name="code"
                                 placeholder="Enter your organization Code"
                               />
                               <br />
                               <Label>Password</Label>
                               <Input
                                 bsSize="lg"
                                 type="password"
                                 name="password"
                                 placeholder="Enter your Password"
                               />
                             </FormGroup>
                             {/* <Link to="auth/reset"></Link> */}
                             {/* <small>
                           <Link to="/auth/reset">Forgot password?</Link>
                         </small> */}
                             <div className="text-center mt-3">
                               {/* <Link to="/dashboard"> 
                          <Button color="primary" size="lg"  onSubmit={this.onFormSubmit}>               
                          Sign in
                        </Button>  
                         </Link> */}
                               {/* <a href="http://localhost:3000/dashboard" > 
                         <Button color="primary" size="lg"  onSubmit={this.onFormSubmit}>               
                          Sign in
                        </Button>        
                      </a> */}
                             </div>
                             {/* <a href="<?=site_url('user_verification? email=' . $email );?> ">Click To Verifiy Email </a> */}
           
                             <div className="text-center mt-3">
                               {/* <a href="<?=site_url('user_verification?email=' . $email );?> ">Click To Verifiy Email </a> */}
           
                               {/* <Link to="auth/reset"> */}
                               <Button type="button" color="primary" style={{ margin: "0rem 1.50rem 0rem 0rem" }} size="lg" onClick={this.onFormSubmit}>
                                 submit
                               </Button>
                               <Button type="button" color="primary" size="lg" onClick={this.onFormCancel}>
                                 Cancel
                               </Button>
                               {/* <Link to={'/' + myConstClass.TENANT_PAGE_PATH + "attendance/listing"} style={{ margin: "0rem 1.50rem 1.50rem 0rem", border: "#6f42c1 1px solid", color: "#6f42c1", padding: "0.10rem 0.90rem 0.30rem 0.90rem", textDecoration: 'none', borderRadius: '0.2rem' }}>{T("Cancel")}</Link> */}
           
                               {/* <Button disabled={submitted}>{
                                         (submitted && 'Your form is submitted!')
                                         || (!submitted && 'Submit')
                                     }</Button> */}
                               {/* </Link> */}
                             </div>
           
                             {/* <center><img src={image3} style={{'width':'40%'}}></img><br/>    */}
                             {/* <p><a href="https://www.epenh.com" target="_blank">Developed by Epenh Co. Ltd © 2019</a></p></center> */}
           
                           </Form>
                         </div>
            </div>

            {/* ---------- QR CODE STEP (redesigned) ---------- */}
            <div style={this.state.form == '0' ? { display: 'block' } : { display: 'none' }}>
              <div className="qr-outer-wrap" style={{ padding: 0 }}>
                <Card className="qr-card">
                  <div className="qr-brand-header">
                    {/* <img className="brand-logo" src={this.state.logo} alt="Work Zone Plus" /> */}
                  </div>

                  <div className="qr-org-panel">
                    <div className="qr-org-logo-wrap">
                      <img src={this.state.logo} alt="Organization logo" />
                    </div>
                    <p className="qr-org-name">{this.state.title}</p>

                    <span className={`qr-type-badge ${isDynamic ? 'dynamic' : 'static'}`}>
                      <span className="qr-type-dot"></span>
                      {isDynamic ? 'Dynamic QR' : 'Static QR'}
                    </span>

                    <div className="qr-code-frame">
                      <span className="qr-corner tl"></span>
                      <span className="qr-corner tr"></span>
                      <span className="qr-corner bl"></span>
                      <span className="qr-corner br"></span>
                      <img src={this.state.qrcode} alt="Organization QR code" />
                    </div>

                    <p className="qr-instructions">
                      {isDynamic
                        ? 'Scan this QR code to check in or check out. It refreshes automatically.'
                        : 'Scan this QR code to check in or check out for this organization.'}
                    </p>

                    <div>
                      <Button className="qr-back-btn" size="lg" onClick={this.onFormCancel}>
                        Go to Login
                      </Button>
                    </div>
                  </div>
                </Card>
              </div>
            </div>
          </CardBody>
        </Card>
        {/* <center><img src={image3} style={{'width':'35%'}}></img><br/>   
       <p><a href="https://www.epenh.com" target="_blank">Developed by Epenh Co. Ltd © 2019</a></p></center> */}
      </React.Fragment>
    )
  }
}

export default LogInForm;